export default __webpack_public_path__ + "static/media/goodbye-message-icon.d2793c07.svg";